import { gql } from "@apollo/client";

export const ME_USER_QUERY = gql`
  query ME_USER_QUERY {
    me {
      id
      name
      createdAt
      resumes {
        id
        title
        createdAt
        file {
          id
          createdAt
          path
        }
      }
      location {
        id
        name
      }
      role {
        id
        name
        permissions {
          id
          object
          actions
        }
      }
      favorites {
        id
        job {
          id
        }
      }
    }
  }
`;

// Production `me` only includes applications when variables.jobId is set.
// Asking for applications on the global session query returns null and fails login/header.
// $jobId must appear in the document (GraphQL rejects unused variables). The `where`
// also keeps the variable live; `me` still reads the same jobId from the request body.
export const CHECK_USER_APPLICATION_STATUS_QUERY = gql`
  query CHECK_USER_APPLICATION_STATUS_QUERY($jobId: String!) {
    me {
      id
      applications(where: { jobId: { equals: $jobId } }) {
        id
        job {
          id
        }
      }
    }
  }
`;

export const SINGLE_USER_QUERY = gql`
  query ME_USER_QUERY($id: String!) {
    user(where: { id: $id }) {
      id
      name
      createdAt
      email
      applications {
        id
        createdAt
      }

      location {
        id
        name
      }

      role {
        id
        name
        permissions {
          object
          actions
        }
      }

      branch {
        id
        name
      }

      otherBranches {
        id
        name
      }

      resumes(orderBy: { createdAt: desc }) {
        id
        title
        file {
          id
          path
          createdAt
          updatedAt
        }
      }
    }
  }
`;
